<template>
  <Layout>
    <Loader :loading="loading" no-axios>
      <div v-if="(model || {}).id">
        <div class="row">
          <div class="col-md-12">
            <a @click="$router.back()">
              <div class="container-title d-flex align-items-center">
                <span class="me-2">
                  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.875 15.3001L0.275 8.70008C0.175 8.60008 0.104 8.49175 0.0619998 8.37508C0.0206665 8.25842 0 8.13342 0 8.00008C0 7.86675 0.0206665 7.74175 0.0619998 7.62508C0.104 7.50842 0.175 7.40008 0.275 7.30008L6.875 0.700082C7.05833 0.516749 7.28733 0.420749 7.562 0.412083C7.83733 0.404083 8.075 0.500082 8.275 0.700082C8.475 0.883416 8.57933 1.11242 8.588 1.38708C8.596 1.66242 8.5 1.90008 8.3 2.10008L3.4 7.00008H14.575C14.8583 7.00008 15.096 7.09575 15.288 7.28708C15.4793 7.47908 15.575 7.71675 15.575 8.00008C15.575 8.28342 15.4793 8.52075 15.288 8.71208C15.096 8.90408 14.8583 9.00008 14.575 9.00008H3.4L8.3 13.9001C8.48333 14.0834 8.57933 14.3167 8.588 14.6001C8.596 14.8834 8.5 15.1167 8.3 15.3001C8.11667 15.5001 7.88333 15.6001 7.6 15.6001C7.31667 15.6001 7.075 15.5001 6.875 15.3001Z"
                        fill="#6C7589"
                    />
                  </svg>
                </span>

                {{ cardTitle }}
              </div>
            </a>
            <b-card v-bind="cardAttrs">
              <b-card-body>
                <div class="row">
                  <div class="col-md-7">
                    <div class="">
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.shows.id`)) }}
                        </div>
                        <div class="col-md-8 value text-sm">
                          {{ model.id }}
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.ticket_id`)) }}
                        </div>
                        <div class="col-md-8 value text-sm">
                          <router-link :to="`/tickets/${model.paymentable.ticket.id}`"
                          >{{
                              `${model.paymentable.ticket.id} (${this.$t(`tickets.customer_types.${model.paymentable.ticket.customer_type}`)})`
                            }}
                          </router-link>
                        </div>
                      </div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-4 label font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.invoice_number`)) }}
                        </div>
                        <div class="col-md-8 value text-sm d-flex gap-1">
                          <div>
                            {{ model.invoice_number }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-4 d-flex flex-column gap-3">
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.from`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ lodash.startCase(model.from_bank_account.customer.name) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.to`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ lodash.startCase(model.to_bank_account.customer.name) }}
                      </div>
                    </div>
                    <div v-if="model.nominal > 0" class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.nominal`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $numeral(model.nominal).format("$ 0,[00]") }}
                      </div>
                    </div>
                    <div v-if="model.paymentable && model.paymentable.remaining_receivable > 0" class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.underpaid`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $numeral(model.paymentable.remaining_receivable).format("$ 0,[00]") }}
                      </div>
                    </div>

                  </div>
                  <div class="col-md-4 d-flex flex-column gap-3">
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.from_bank_account`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ bankAccountFormat(model.from_bank_account) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.to_bank_account`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ bankAccountFormat(model.to_bank_account) }}
                      </div>
                    </div>
                    <div class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.paid_at`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $moment.utc(model.paid_at).local().format("DD MMMM YYYY") }}
                      </div>
                    </div>
                    <div v-if="isOverpaid" class="description-detail">
                      <div class="label font-size-500">
                        {{ lodash.startCase($t(`${this.resourceRoute}.overpaid`)) }}
                      </div>
                      <div class="text-neutral-600">
                        {{ $numeral(model.nominal - model.paymentable.total).format("$ 0,[00]") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div>
                      <div class="row g-0 description-detail">
                        <div class="col-md-12 font-size-500">
                          {{ lodash.startCase($t(`${this.resourceRoute}.attachment`)) }}
                        </div>
                        <div class="col-md-12 value no-colon">
                          <attachment
                              v-if="model.files.length"
                              :files="model.files"
                          ></attachment>
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr>
                <div class="description-detail">
                  <div class="label font-size-500">
                    {{ lodash.startCase($t(`${this.resourceRoute}.description`)) }}
                  </div>
                  <div class="text-neutral-600">
                    <span v-if="model.description" v-html="model.description"></span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="row col-md-6 auditable" v-if="model.creator">
                  <div class="col-md-3">
                    {{ lodash.startCase(this.$t(`CreatedBy`)) }}
                  </div>
                  <div class="col-md-6 font-size-10">: {{ model.creator.name }}</div>
                </div>
                <div class="row col-md-6 auditable">
                  <div class="col-md-3">
                    {{ lodash.startCase(this.$t(`CreatedAt`)) }}
                  </div>
                  <div class="col-md-6 label-auditable font-size-10">
                    :
                    {{
                      $moment
                        .utc(model.created_at)
                        .local()
                        .format("DD MMMM YYYY")
                    }}
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import ModelShow from '../models/show';
import Row from '@/components/models/show/custom-row';
import Loader from "@/components/widgets/loader";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Sale Invoice",
  },
  components: {
    Loader,
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('sale_invoices.singular')) }},
    resourceRoute: {default: 'sale_invoices'},
    modelVariable: {default: 'sale_invoice'},
    denyEdit: {type: Boolean, default: true},
    denyDelete: {type: Boolean, default: true},
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || 'model']: [
            {
              key: 'key',
              label: this.$t('models.key'),
              component: Row
            }
          ]
        };
      }
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('sale_invoices.plural')),
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    isOverpaid() {
      return this.model.nominal > this.model.total
    },
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t('sale_invoices.plural')),
          href: "/sale_invoices",
        },
        {
          text: this.model && this.model.id ? this.model.order_id : this.$route.params.key,
          href: `/sale_invoices/${this.$route.params.key}`,
          active: true,
        }
      ]
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model) ? [] : [
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.ticket_id`)),
          value: `${this.model.paymentable.tickets[0].id} (${this.lodash.upperCase(this.model.paymentable.tickets[0].customer_type)})`,
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.date`)),
          value: this.$moment.utc(this.model.paid_at).local().format('DD MMMM YYYY'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.from`)),
          value: `${this.lodash.startCase(this.model.from_bank_account.customer.name)}`,
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.from_bank_account`)),
          value: this.bankAccountFormat(this.model.from_bank_account),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.to`)),
          value: `${this.lodash.startCase(this.model.to_bank_account.customer.name)}`,
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.to_bank_account`)),
          value: this.bankAccountFormat(this.model.to_bank_account),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.nominal`)),
          value: this.$numeral(this.model.debit).format('$ 0,0.[00]'),
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.purchase_number`)),
          value: this.model.invoice_number,
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.$t(`files`),
          item: this.model,
          value: {
            props: { item: {type: Object, default() { return [] }} },
            template:
                '<div class="row">' +
                '<div v-for="(i, key) in item.files" class="col-md-6">' +
                '<p>File {{key + 1}}</p>' +
                '<PreviewImagePdf :preview="i.url" :format="i.extension"/>' +
                '</div>' +
                '</div>'
          }
        },
        {
          key: this.lodash.startCase(this.$t(`sale_invoices.description`)),
          item: this.model.description,
          value: {
            props: { item: {type: String, default: ''} },
            template: `<span v-html="item || '-'"></span>`
          },
          class: 'row',
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`${this.resourceRoute}.created_at`)),
          value: this.$moment.utc(this.model.created_at).local().format('DD MMMM YYYY'),
          class: 'row',
          styles: { fontSize:'10px', opacity: '0.8' },
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
        {
          key: this.lodash.startCase(this.$t(`CreatedBy`)),
          value: this.lodash.startCase(this.model.creator.name),
          class: 'row',
          styles: { fontSize:'10px', opacity: '0.8' },
          labelClass: 'col-sm-12 col-md-2',
          valueClass: 'col-sm-12 col-md-9',
          showColon: true,
        },
      ]
    }
  },
  methods: {
    bankAccountFormat(bank_account){
      let bankName = bank_account.bank.name;
      let regex = /\(([^)]+)\)/;
      let matches = regex.exec(bankName);
      if (matches) {
        bankName = matches[1];
      }
      return [bank_account.name, bank_account.account_number, bankName].filter(d=>!!d).join(' - ');
    },
    getModelName() {
      return this.model['order_id'];
    },
    delete() {
      return this.$axios.delete(`/sale_payments/${this.$route.params.key}`)
    },
    fetchModel() {
      this.loading = true;
      return this.$axios.get(`/payments/${this.$route.params.key}`, {
        params: {
          with: 'paymentable.ticket,from_bank_account.bank,from_bank_account.customer,to_bank_account.bank,to_bank_account.customer,files,creator'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .preloader-component {
    background-color: #ffffff;
  }
}

.container-title {
  margin-top: 10px;
  font-family: Lato;
  font-size: 12px;
  font-weight: 800;
  line-height: 14px;
  letter-spacing: 0.05em;
  text-align: left;
  margin-bottom: 8px;
  text-transform: uppercase;
  font-family: "Lato";
  color: #6c7589;
}

.custom-group {
  margin-bottom: 30px;
}

.custom-label,
.custom-text {
  font-family: Lato;
  font-size: 14px;

  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

.custom-label,
.label {
  font-weight: 700;
  color: #161b4d;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.custom-text,
.value {
  font-weight: 400;
  color: #6c7589;
}

.value:not(.no-colon)::before {
  content: ": ";
}

.section-title {
  background-color: #f9fafb;
  color: #161b4d;
  padding: 14px 21px;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
  border: 1px solid #ececf2;
}

.section-title:first-of-type {
  border-top: none;
}

.section-body {
  padding: 14px 20px;

  .section-label,
  .section-value {
    font-family: Lato;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
  }

  .section-label {
    color: #161b4d;
    font-weight: 400;
  }

  .section-value {
    color: #161b4d;
    font-weight: 700;
    text-align: right;
  }

  .section-row {
    padding: 6px 0;
  }
}

.sale-item-thead {
  color: #161b4d;
  background-color: #f9fafb;
  text-transform: uppercase;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.05em;
  text-align: left;
}

.sale-item-tbody {
  color: #161b4d;
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0em;
  text-align: left;
}

::v-deep .page-content {
  background: #eef3f7;
}

$badge-background-primary: rgba(198, 239, 255, 0.3);
$badge-color-primary: #0084f3;
$badge-background-warning: #fff8e7;
$badge-color-warning: #ff9d0b;

.badge-container {
  &-base {
    background: $badge-background-primary;

    .stakeholder {
      color: #161b4d;
      font-weight: 700;
      font-size: 14px;
    }

    .name {
      font-weight: 700;
      font-size: 20px;
    }
  }

  &-primary {
    @extend .badge-container-base;

    .name {
      color: $badge-color-primary;
    }
  }

  &-warning {
    @extend .badge-container-base;
    background: $badge-background-warning;

    .name {
      color: $badge-color-warning;
    }
  }
}

::v-deep {
  .overflow-hidden {
    overflow: hidden !important;
  }

  table {
    thead {
      background: #f9fafb !important;
    }
  }
}
.auditable {
  color: #737373;
  font-weight: 400;
}
</style>